import React, { Component, ErrorInfo, ReactNode } from 'react'
import posthog from 'posthog-js'
import track from 'src/helpers/track'
import { isPosthogReady } from 'src/helpers/posthog'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true }
  }

  // eslint-disable-next-line class-methods-use-this
  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // eslint-disable-next-line no-console
    const errorString = JSON.stringify({ error: error.toString(), errorInfo: JSON.stringify(errorInfo) })
    track('dealer_global_error', { error: errorString })
    if (isPosthogReady()) {
      posthog.captureException(error)
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleReload = (): void => {
    window.location.reload()
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
            gap: '20px'
          }}>
          <h1>sorry, an error occurred</h1>
          <button
            onClick={this.handleReload}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              cursor: 'pointer',
              backgroundColor: '#3582ce',
              color: 'white',
              border: 'none',
              borderRadius: '4px'
            }}>
            Reload Page
          </button>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
